import { combineReducers } from 'redux'
import { UserReducer } from '../Reducers/UserReducer'
import { organizationReducer } from '../../app/screens/mainScreens/organization'
import {departmentReducer} from '../../app/screens/mainScreens/department'


export default combineReducers({
    user: UserReducer,
   
    
})